module.exports = __webpack_public_path__ + "img/img1.7928b86a.png";